import { ShoppingOutlineIcon } from './ShoppingOutlineIcon';

/**
 * author: Google
 * id EBE771F9-2EF2-41D9-AE7D-8FDBA1B4C684
 * name shopping-outline
 * version: 4.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/shopping-outline.svg
 * tags
 * - Shopping 
 */
export const LocalMallOutlineIcon = ShoppingOutlineIcon;
export default LocalMallOutlineIcon